import { render, staticRenderFns } from "./apinvlist.vue?vue&type=template&id=563d3db4"
import script from "./apinvlist.vue?vue&type=script&lang=js"
export * from "./apinvlist.vue?vue&type=script&lang=js"
import style0 from "./apinvlist.vue?vue&type=style&index=0&id=563d3db4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports